import { fetchPoll } from './../services/ApiController'
import React, {Component} from 'react'
import { PollStyle } from './../styles'
export default class Poll extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: true,
      poll: null,
      choice: null,
      success: false,
      hasFreeChoice: false
    }
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = () => {
    fetchPoll().then((data) => {
      if (data.id) {
        this.setState({poll: data})
      }
    }).catch((err) => {
      console.log('Something Wrong with Poll data', err)
    })
  }

  togglePoll = () => {
    this.setState({isOpen : !this.state.isOpen })
  }

  sendChoice = () => {
    if (this.state.choice !== null && this.state.choice !== '') {
      fetch(`/survey/${this.state.poll.id}.json`, {
        body: JSON.stringify({choice: this.state.choice}),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }).then(() => {
        this.setState({success: true})
        setTimeout(() => {
          this.setState({isOpen: false})
        }, 3000)
      }).catch((err) => {
        console.log('Something Wrong with sending datas', err)
      })
    } else {
      this.setState({error: true})
    }
  }

  render() {
    return this.state.poll !== null && (
      <div className={`poll  ${!this.state.isOpen ? 'is-closed' : ''} ${PollStyle}`}>
        <button className="poll__close" onClick={() => this.togglePoll()}>
          <svg className="shape shape--arrow" width="18" height="18" viewBox="0 0 129 129">
            <path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"/>
          </svg>
        </button>
        <p className="poll__title">{this.state.poll.title}</p>
        
        { !this.state.success &&
          <div>
            <fieldset>
              <legend className="poll__question">{this.state.poll.question}</legend>
              
              { this.state.poll.choices.map((choice, i) => {
                return (
                  <div className="poll__radio" key={i}>
                    <input onChange={() => this.setState({choice: choice, error: false, hasFreeChoice: false})} type="radio" id={choice} value={choice} name="poll" />
                    <label htmlFor={choice}>{choice}</label>
                  </div>
                )
              }) }

              { this.state.poll.addFreeTextChoice &&
                <div className="poll__free-wrap">
                  <div className="poll__radio">
                      <input onChange={() => this.setState({hasFreeChoice: true, error: false})} type="radio" id="other" value="other" name="poll" />
                      <label htmlFor="other">Other</label>
                    </div>

                    { this.state.hasFreeChoice &&
                      <div className="poll__free">
                        <label htmlFor="otherText">Please explain</label>
                        <input onChange={(e) => this.setState({ choice: e.target.value, error: e.target.value === '' ? true : false })} id="otherText" type="text" placeholder="Please explain" />
                      </div>
                    }
                </div>
              }
            </fieldset>
            <input onClick={() => this.sendChoice()} className="poll__submit" type="submit" value="Submit" />
          </div>
        }

        {this.state.error &&
          <p className="poll__error">Please select an answer</p>
        }

        {this.state.success &&
          <p className="poll__success">Thank you, your answer has been taken into account</p>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Poll.js